import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { ResourceInterface } from '@/shared/component/resource.interface';
import { IEmailTemplate } from '@/shared/model/email-template.model';

const baseApiUrl = 'api/private/email-templates';

export default class EmailTemplateService implements ResourceInterface {
  public find(id: number): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public createDefaults(resellerId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/defaults/reseller/${resellerId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

}
